import genericApi from './genericApi';

import Payment from '../models/Payment';
import PaymentsPO from '../models/PaymentsPO';
import ApiResponse from '../models/ApiResponse';
import GhaPoAwbPayments from '../models/GhaPoAwbPayments';
import PaymentDetails, { PaymentDetailsAwb } from '../models/PaymentDetails';
import { PaymentReport } from '../models/PaymentReport';
import PaymentDetailsHistoryAwbs from '../models/PaymentHistory';
import AlternativePaymentOptions from '../models/PaymentOptions';
import { PaymentAuditModel } from '../models/PaymentAudit';

const paymentRequestHandler = {

  getPaymentsAwbFwd: (cartAwbs: Array<{ code: string; number: string }>, status: string): Promise<ApiResponse<Array<Payment>>> => {

    return genericApi.post(`payments/awb?status=${status}`, { awbs: cartAwbs });
  },
  getGhaPoAwbPaymentsStatus: (data: Array<{ code: string, number: string, version: number }>, orderNo: string): Promise<ApiResponse<GhaPoAwbPayments>> => {

    return genericApi.post(`payments`, { awbs: data, order_no: orderNo });
  },
  getPaymentDetails: (id: number, poNumber: string): Promise<ApiResponse<PaymentDetails>> => {

    return genericApi.get(`payment/${id}/${poNumber}`);
  },

  getPaymentDetailsByOrder: (poNumber: string): Promise<ApiResponse<PaymentDetails>> => {

    return genericApi.get(`payment/${poNumber}`);
  },
  getPaymenAwbDetails: (code: string, number: string, version: number, orderNumber?: string): Promise<ApiResponse<PaymentDetailsAwb>> => {

    return genericApi.get(`payment/awb/${code}/${number}/${version}/${orderNumber}`);
  },
  setPaymentStatus: (id: number, data: { status: string, reason: string }, orderNo: string): Promise<ApiResponse<boolean>> => {

    return genericApi.put(`payment/${id}/status/${orderNo}`, data);
  },

  addRemarks: (id: number, remarks: string): Promise<ApiResponse<boolean>> => {

    return genericApi.put(`payment/remarks/${id}`, { remarks: remarks });
  },
  getPaymentHistory: (code: string, number: string): Promise<ApiResponse<Array<PaymentDetailsHistoryAwbs>>> => {

    return genericApi.get(`payment_history/${code}/${number}`);
  },
  insertPaymentAdjustment: (code: string, number: string, version: number, paymentId: number, payment: PaymentAuditModel, amountTotal: number, remarks: string, startDate: string, endDate: string): Promise<ApiResponse<number>> => {

    return genericApi.post(`adjustment/${code}/${number}/${version}/${paymentId}?start_date=${startDate}&end_date=${endDate}`, { payment, amount_collected: amountTotal, remarks });
  },
  insertReturnPayment: (code: string, number: string, orderId: number, payment: PaymentAuditModel, amountTotal: number, remarks: string): Promise<ApiResponse<number>> => {

    return genericApi.post(`return/${code}/${number}/${orderId}`, { payment, amount_collected: amountTotal, remarks });
  },
  getPaymentAdjustments: (code: string, number: string, version: number, id: number, type: string): Promise<ApiResponse<Array<PaymentAuditModel>>> => {
    let url = `adjustment/${code}/${number}/${version}/${id}?type=${type}`;
    return genericApi.get(url);
  },

  getLatestCharges: (): Promise<ApiResponse<Array<PaymentAuditModel>>> => {
    let url = `return_charges`;
    return genericApi.get(url);
  },
  deletePaymentAdjustment: (code: string, number: string, version: number, id: number, startDate: string, endDate: string): Promise<ApiResponse<number>> => {

    return genericApi.delete(`adjustment/${code}/${number}/${version}/${id}?start_date=${startDate}&end_date=${endDate}`);
  },
  deleteConfirmedService: (code: string, number: string, version: number, serviceName: string): Promise<ApiResponse<any>> => {
    return genericApi.delete(`service/${code}/${number}/${version}/${serviceName}`);
  },
  settlePayment: (id: number, value: boolean): Promise<ApiResponse<boolean>> => {

    return genericApi.put(`payment/settled/${id}`, { settled: value });
  },

  getPaymentOptions: (): Promise<ApiResponse<AlternativePaymentOptions>> => {

    return genericApi.get(`alt_payment_options`);
  },

  getPoPayments: (cartAwbs: Array<{ code: string; number: string; }>, status: string): Promise<ApiResponse<PaymentsPO>> => {

    return genericApi.post(`payments?status=${status}`, { awbs: cartAwbs });
  },

  getPaymentsByFwdOrGha: (services: string[], opts: { fwdId?: number, ghaId?: number, startDate?: string, endDate?: string, paymentMethod?: string, alternativePaymentMethod?: string, airlineId?: string, awbNumber: string, settled: boolean, overpaid: boolean, underpaid: boolean, limit?: number, offset?: number }): Promise<ApiResponse<PaymentReport>> => {

    let url = `payments/report?show_services=${JSON.stringify(services)}&`;
    if (opts.fwdId && opts.fwdId > 0)
      url += `fwdId=${opts.fwdId}&`;
    if (opts.ghaId && opts.ghaId > 0)
      url += `ghaId=${opts.ghaId}&`;
    if (opts.startDate)
      url += `start_date=${opts.startDate}&`;
    if (opts.endDate)
      url += `end_date=${opts.endDate}&`;
    if (opts.paymentMethod)
      url += `payment_method=${opts.paymentMethod}&`;
    if (opts.alternativePaymentMethod)
      url += `alternative_payment_method=${opts.alternativePaymentMethod}&`;
    if (opts.airlineId)
      url += `airline=${opts.airlineId}&`;
    if (opts.awbNumber)
      url += `awb=${opts.awbNumber}&`;
    if (opts.settled !== undefined)
      url += `settled=${opts.settled}&`;
    if (opts.overpaid !== undefined)
      url += `overpaid=${opts.overpaid}&`;
    if (opts.underpaid !== undefined)
      url += `underpaid=${opts.underpaid}&`;
    if (opts.limit !== undefined)
      url += `limit=${opts.limit}&`;
    if (opts.offset !== undefined)
      url += `offset=${opts.offset}&`;

    return genericApi.get(url);
  }
};

export default paymentRequestHandler;